"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var useTheme_1 = require("@material-ui/core/styles/useTheme");
var useMediaQuery_1 = require("@material-ui/core/useMediaQuery");
var IconButton_1 = require("@material-ui/core/IconButton");
var Cancel_1 = require("@material-ui/icons/Cancel");
var HighlightOffOutlined_1 = require("@material-ui/icons/HighlightOffOutlined");
var modalPaperStyles_1 = require("./modalPaperStyles");
var ModalPaper = function (_a) {
    var className = _a.className, children = _a.children, hideCloseIcon = _a.hideCloseIcon, onClose = _a.onClose, toggleModal = _a.toggleModal, rest = __rest(_a, ["className", "children", "hideCloseIcon", "onClose", "toggleModal"]);
    var styles = modalPaperStyles_1.default();
    var isBelowTablet = useMediaQuery_1.default(useTheme_1.default().breakpoints.down('sm'));
    var handleClose = react_1.useCallback(function () { return toggleModal(false); }, [toggleModal]);
    return (<core_1.Paper {...rest} className={className} classes={{ root: styles.overlayPaper }}>
      {!hideCloseIcon && (<IconButton_1.default onClick={onClose ? onClose : handleClose} data-test={'button:close'} className={styles.closeButton}>
          {isBelowTablet ? <Cancel_1.default className={styles.closeIcon}/> : <HighlightOffOutlined_1.default />}
        </IconButton_1.default>)}
      <core_1.Box className={[className, styles.insetPaper].join(' ')}>{children}</core_1.Box>
    </core_1.Paper>);
};
exports.default = ModalPaper;
